<div class="block">
    <ridango-page-content-wrapper>
        <div class="ticket">
            <div class="intro-text">
                <p class="title">
                    {{ 'PURCAHSE_TITLE_CARDS' | translate }}
                </p>
                <p>
                    {{ 'PURCAHSE_DESCRIPTION_CARDS' | translate }}
                </p>
                <p>{{ 'BUY_DIFFERENT_TICKETS' | translate }}</p>
            </div>

            <div class="multiple-card-area">
                <div class="multiple-card-area__block-title">
                    <p class="title">
                        <span style="padding-right: 3px">{{ (travelCardsIds$ | async).length }}</span>
                        <span>{{ 'TRAVEL_CARDS' | translate }}</span>
                    </p>
                    <button class="btn btn--primary" [routerLink]="'/account/related-cards/add' | localize">
                        {{ 'ADD_TRAVEL_CARDS' | translate }}
                    </button>
                    <button class="btn btn--primary mobile" [routerLink]="'/account/related-cards/add' | localize">
                        {{ 'ADD' | translate }}
                    </button>
                </div>

                <div
                    class="multiple-card-area__user"
                    *ngIf="(travelCardsIds$ | async).length > 0"
                    [ngClass]="{ scroll: (travelCardsIds$ | async).length >= 15 }">
                    <div class="table w-full">
                        <div class="tableHeader">
                            <div class="row-items table-content odd">
                                <div class="col-item w1 checkbox-mobile">
                                    <span class="checkbox">
                                        <input
                                            class="checkbox__checkbox"
                                            id="card-selection"
                                            [checked]="
                                                (travelCardsIds$ | async).length > 0 &&
                                                (travelCardsIds$ | async).length ===
                                                    (selectedTravelCardsIds$ | async).length
                                            "
                                            (click)="toggleAllTravelCards()"
                                            type="checkbox" />
                                        <label class="checkbox__label" for="card-selection"></label>
                                    </span>
                                </div>

                                <div class="col-item w3 show-mobile hide-desktop">
                                    <span class="select-all-mobile">{{ 'SELECT_ALL' | translate }}</span>
                                </div>

                                <div class="col-item w3 hide-mobile">
                                    <a class="pn-dark:!text-black card_number" (click)="sortByNumber()">
                                        <span>{{ 'CARD_NUMBER' | translate }}</span>
                                        <span
                                            class="icon icon-arrow-filter"
                                            *ngIf="(sortField$ | async) === 'card_nr'"
                                            [ngClass]="{ desc: (sortDirection$ | async) === 'desc' }"></span>
                                    </a>
                                </div>

                                <div class="col-item w4 hide-mobile">
                                    <a class="pn-dark:!text-black card_name" (click)="sortByName()">
                                        <span>{{ 'CARD_NAME' | translate }}</span>
                                        <span
                                            class="icon icon-arrow-filter"
                                            *ngIf="(sortField$ | async) === 'name'"
                                            [ngClass]="{ desc: (sortDirection$ | async) === 'desc' }"></span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <ridango-table-row
                            *ngFor="let card of travelCardsIds$ | async; let even = even"
                            [isEven]="even"
                            (click)="travelCardClicked(card)">
                            <div class="col-item w1 checkbox-mobile">
                                <span class="checkbox">
                                    <input
                                        class="checkbox__checkbox"
                                        id="{{ (allNormalized$ | async)[card].card_nr }}"
                                        [checked]="(selectedTravelCardsIds$ | async).indexOf(card) > -1"
                                        type="checkbox"
                                        disabled />
                                    <label
                                        class="checkbox__label"
                                        for="{{ (allNormalized$ | async)[card]?.card_nr }}"></label>
                                </span>
                            </div>

                            <div class="col-item w3">
                                <span class="card-number-mobile">{{ 'CARD_NUMBER' | translate }}</span>
                                {{ (allNormalized$ | async)[card]?.card_nr }}
                            </div>

                            <div class="col-item w4">
                                <span class="card-name-mobile">{{ 'CARD_NAME' | translate }}</span>
                                {{ (allNormalized$ | async)[card]?.name }}
                            </div>
                        </ridango-table-row>
                    </div>
                </div>

                <div class="multiple-card-area__block-empty-state" *ngIf="(travelCardsIds$ | async).length === 0">
                    <p>{{ 'NO_TRAVEL_CARDS' | translate }}</p>
                </div>
            </div>
            <ridango-arrow-down-separator></ridango-arrow-down-separator>
        </div>
    </ridango-page-content-wrapper>

    <div class="block--bg-wrapper ticket-summary">
        <ridango-page-content-wrapper>
            <div class="block-title-card-selected">
                <p>
                    <span style="padding-right: 3px">{{ (selectedTravelCardsIds$ | async).length }}</span>
                    <span>{{ 'SELECTED_TRAVEL_CARDS' | translate }}</span>
                </p>
            </div>

            <div class="multiple-card-selected-area-button" *ngIf="(selectedTravelCardsIds$ | async).length > 0">
                <button
                    class="btn btn--primary"
                    [disabled]="(selectedTravelCardsIds$ | async).length === 0"
                    (click)="proceedToTicketSelection()">
                    {{ 'PROCEED_TICKET_SELECTION' | translate }}
                </button>
            </div>

            <div class="block-description-card-selected" *ngIf="(selectedTravelCardsIds$ | async).length === 0">
                <p>
                    <span>{{ 'PLEASE_SELECT_TRAVEL_CARDS' | translate }}</span>
                </p>
            </div>
        </ridango-page-content-wrapper>
    </div>
</div>
